/**
 *
 * @see https://github.com/angular/angular/blob/master/packages/core/src/sanitization/url_sanitizer.ts
 *
 */

const SAFE_URL_PATTERN =
  /^(?:(?:https?|mailto|ftp|tel|file|ghs|grubhybrid):|[^&:/?#]*(?:[/?#]|$))/gi;

/** A pattern that matches safe data URLs. Only matches image, video and audio types. */
const DATA_URL_PATTERN =
  /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+/]+=*$/i;

export function sanitizeUrl(url: string): string {
  url = String(url);
  if (url.match(SAFE_URL_PATTERN) || url.match(DATA_URL_PATTERN)) {
    return url;
  }

  throw new Error('unsafe URL: ' + url);
}
